import { Component, OnInit, Input } from '@angular/core';

import { LexTranslateService } from '@app/core/services/lex-translate.service';

@Component({
  selector: 'seb-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.css']
})
export class PreloaderComponent implements OnInit {

  @Input() hidden: boolean;
  @Input() preloaderLabel: string;
  @Input() preloaderStyle: object;
  @Input() preloader2 = false;
  @Input() containerStyle: object;
  @Input() spinnerStyle: object;
  @Input() preloader2Hidden: boolean;

  constructor(private lextranslate: LexTranslateService) { }

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()

    this.preloaderLabel = this.lextranslate.i18n["5c07b3c9-dd95-48a3-bab9-5eb2bd57991f"]
  }

}
